module.exports = __webpack_public_path__ + "static/img/276_TO8_2406_og.d36b97e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/276_TO8_2406_og.jpg
// module id = R6Sg
// module chunks = 0